import React from 'react'
import { Modal, ModalHeader, Button } from 'reactstrap';
import { FormPayMethods } from './FormPayMethods';
import { ModalButtonSave, ModalButtonUpdate } from '../../constant';
import { DeletePayMethods } from './DeletePayMethods';
import { Dialog } from 'primereact/dialog';

export const ModalPayMethods = (props) => {

    const {
        modal, modalTitle, closeDialog, method, loading,
        name, abbreviation, handleInputChange, validaciones,
        saveCreate, saveUpdate, saveDelete
    } = props;

        const footer = (
            <>
            <Button
                color="danger"
                size="sm"
                onClick={closeDialog}
            >
                Cancelar
            </Button>

            <Button
                color="primary"
                size="sm"
                onClick={method === "create" ? saveCreate : saveUpdate}
                className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}
            >
                Confirmar
            </Button>
            </>

    );



    return (
        <Dialog 
            header={modalTitle} 
            visible={modal} 
            onHide={closeDialog} 
            closable 
            modal 
            blockScroll 
            className='medium-dialog'
            footer={footer}>
            {
                method === "create"
                    ? <FormPayMethods button={ModalButtonSave} {...{loading, handleInputChange, validaciones, methodAction: saveCreate }} />
                    : (method === "update")
                        ? <FormPayMethods button={ModalButtonUpdate} {...{ loading, handleInputChange, validaciones, methodAction: saveUpdate, name, abbreviation }} />
                        : null
            }
        </Dialog>
    )
}
